import { StyleSelector } from 'components/styles/primitives/modifiers/types'
import { css } from '@emotion/react'
import { MaxWidthByDevice } from 'parameters/viewport'

/**
 * Applies the passed styles to devices with screen sizes smaller than 580px
 * @param {CSSInterpolation} styles
 * @returns {StyleSelector}
 */
export const ifMobileScreen: StyleSelector = styles => css`
	@media only screen and (max-width: ${MaxWidthByDevice.Mobile}px) {
		${styles}
	}
`
